import * as React from 'react';
import { graphql } from 'react-apollo';

import { compose } from 'recompose';

import connectToRouter from 'js/lib/connectToRouter';

import PortfolioProjectCheckContext from 'bundles/unified-description-page-common/contexts/PortfolioProjectCheckContext';
import { PortfolioProjectQuery } from 'bundles/unified-description-page-common/queries/PortfolioProjectQuery';
import type {
  PortfolioProjectQuery as PortfolioProjectQueryType,
  PortfolioProjectQueryVariables,
} from 'bundles/unified-description-page-common/queries/__generated__/PortfolioProjectQuery';

type PropsToComponent = {
  children: React.ReactNode;
  isPortfolioProject: boolean;
  isLoadingPortfolioProject: boolean;
};

const PortfolioProjectCheckProvider = ({
  children,
  isPortfolioProject,
  isLoadingPortfolioProject,
}: PropsToComponent) => {
  return (
    <PortfolioProjectCheckContext.Provider value={{ isPortfolioProject, isLoadingPortfolioProject }}>
      {children}
    </PortfolioProjectCheckContext.Provider>
  );
};

export default compose<PropsToComponent, {}>(
  connectToRouter(({ params }) => {
    return {
      slug: params.productSlug,
    };
  }),
  graphql<
    { slug: string },
    PortfolioProjectQueryType,
    PortfolioProjectQueryVariables,
    { isPortfolioProject?: boolean }
  >(PortfolioProjectQuery, {
    skip: ({ slug }: { slug: string }) => !slug,
    props: ({ data }) => {
      return {
        isLoadingPortfolioProject: data?.loading,
        isPortfolioProject: Boolean(data?.ExternallyAccessibleNostosV1Resource?.getAllProperties?.elements?.[0]?.id),
      };
    },
  })
)(PortfolioProjectCheckProvider);
